/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import SessionExpireModal from "./SessionExpireModal";
import { Layout } from "./modules/Common/layout";

export function Routes() {

    const user = useSelector( ({auth}) => (auth.user), shallowEqual);

    return (
        <Switch>
            {(!user?.otpSatisfied)  ? (
                /*Render auth page when user at `/auth` and not authorized.*/
                <Route>
                    <AuthPage />
                </Route>
            ) : (
                /* Otherwise redirect to root page (`/`)*/
                <Redirect from="/auth" to="/"/>
                
            )}
            
            <Redirect from="/forgot-password" to="/"/>
            <Redirect from="/reset-password" to="/"/>
            <Route path="/error" component={ErrorsPage}/>
            <Route path="/logout" component={Logout}/>


            {(!user?.otpSatisfied) ? (
                /*Redirect to `/login` when user is not authorized*/
                <Redirect to="/login"/>
            ) : (
                <Layout>
                    <BasePage/>
                    <SessionExpireModal />
                </Layout>
            )}
        </Switch>
    );
}
